import { Component, OnInit } from '@angular/core';
import {   NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit {

  constructor(
    private themeService: NbThemeService
  ) { 
    this.themeService.changeTheme(localStorage.getItem('theme') || 'default')

  }

  ngOnInit() { 
  }

}
